<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_learning_video") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleAr')"
            v-model.trim="data.title_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleEn')"
            v-model.trim="data.title_en"
            disabled
          />
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.video_url')"
            v-model.trim="data.video_url"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowLearningVideo",

  data() {
    return {
      data: {
        title_ar: null,
        title_en: null,
        video_url: null,
      },
    };
  },

  methods: {
    async getData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `learningVideos/${this.$route.params.id}`,
        });
        const item = res.data?.data?.LearningVideo || {};
        this.data.title_ar = item.title_ar;
        this.data.title_en = item.title_en;
        this.data.video_url = item.video_url;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            "Failed to load learning video details"
        );
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>
